import { render, staticRenderFns } from "./ContactTypeTable.vue?vue&type=template&id=4df3de7e"
import script from "./ContactTypeTable.vue?vue&type=script&lang=ts"
export * from "./ContactTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports